import ReportsCreate from "./ReportsCreate";

export default ReportsCreate;
